import * as actionTypes from '../actions/types';

const initialState = {
    data: [],
    error: null,
    loading: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_LOCATION_PENDING:
            return {
                ...state,
                error: '',
                data: [],
                loading: true,
            };
        case actionTypes.GET_LOCATION_FAILURE:
            return {
                ...state,
                error: '',
                data: [],
                loading: false,
            };
        case actionTypes.GET_ALL_LOCATION:
            return {
                ...state,
                error: null,
                data: action.data,
                loading: false,
            };
        case actionTypes.ADD_LOCATION:
            return {
                ...state,
                error: null,
                data: state.data.concat(action.newLocation),
                loading: false,
            };

        default:
            return state
    }
};

